import { CollisionPriority } from '@dnd-kit/abstract';
import { useDroppable } from '@dnd-kit/react';

import { BLANK_COLUMN_ID } from '../types';

/**
 * BlankColumn component - drop zone for creating new apps from tabs.
 * Shows visual feedback when a tab is being dragged over.
 */
export const BlankColumn = () => {
  const { ref, isDropTarget } = useDroppable({
    id: BLANK_COLUMN_ID,
    type: 'new-column',
    accept: ['item'],
    collisionPriority: CollisionPriority.Low
  });

  return (
    <div
      ref={ref}
      className={`relative flex min-h-[40vh] items-center justify-center border-4 border-dashed transition-colors ${
        isDropTarget ? 'border-muted-foreground bg-primary/15' : 'border-transparent bg-card'
      }`}
    >
      <span className='text-sm text-muted-foreground'>Drop a tab here</span>
    </div>
  );
};

export default BlankColumn;
